export { default } from './StaticPageAddress';
